import { Action } from 'redux';

import { RunFlowTaskInfo } from '../../../ts/models/RunFlowTaskInfo';
import { RunFlowTaskChangePriority, RunFlowTaskChangeSchedule, RunFlowTaskEditTask, RunFlowTaskResume, RunFlowTaskRunNow } from '../AppActionTypes';

export interface RunFlowTaskMenuAction extends Action {
  items: RunFlowTaskInfo[];
}

export function runFlowTaskRunNow(items: RunFlowTaskInfo[]): RunFlowTaskMenuAction {
  return {
    type: RunFlowTaskRunNow,
    items
  };
}

export function editFlowTask(items: RunFlowTaskInfo[]): RunFlowTaskMenuAction {
  return {
    type: RunFlowTaskEditTask,
    items
  };
}

export function runFlowTaskChangeSchedule(items: RunFlowTaskInfo[]): RunFlowTaskMenuAction {
  return {
    type: RunFlowTaskChangeSchedule,
    items
  };
}

export function runFlowTaskChangePriority(items: RunFlowTaskInfo[]): RunFlowTaskMenuAction {
  return {
    type: RunFlowTaskChangePriority,
    items
  };
}

export function runFlowTaskResume(items: RunFlowTaskInfo[]): RunFlowTaskMenuAction {
  return {
    type: RunFlowTaskResume,
    items
  };
}
